import type { HeatmapWidgetStateParams } from '@repo/go-widgets';

import type { THeatmapSerializedInternalState } from './HeatmapWidget.entity';

export function parseHeatmapWidgetInternalState(state: object): THeatmapSerializedInternalState {
  let wellId: number | null = null;
  let stateParams: Partial<HeatmapWidgetStateParams> = {};

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && !!state.stateParams) {
    stateParams = state.stateParams as Partial<HeatmapWidgetStateParams>;
  }

  return {
    wellId,
    stateParams,
  };
}
